import { render, staticRenderFns } from "./ModalAddPoll.vue?vue&type=template&id=07c15c25&scoped=true&"
import script from "./ModalAddPoll.vue?vue&type=script&lang=js&"
export * from "./ModalAddPoll.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddPoll.vue?vue&type=style&index=0&id=07c15c25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c15c25",
  null
  
)

export default component.exports